<div
  class="timepicker-container"
  #zuumTimePicker
  [attr.aria-labelledby]="formField?.getLabelId()"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut()"
  [class.readonly]="readonly"
>
  <ngx-timepicker-field
    [format]="format"
    [formControl]="timepickerControl"
    [defaultTime]="timepickerControl.value"
    buttonAlign="right"
    [fbDisableControl]="disable || readonly"
    [min]="config?.min?.toString()"
    [max]="config?.max?.toString()"
    [required]="required"
    [clockTheme]="clockTheme"
  ></ngx-timepicker-field>
</div>
